class MobileDock extends HTMLElement {
  constructor() {
    super();

    this.isAction = false;

    this.header = document.querySelector('sticky-header');

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));

    this.init();
  }

  init() {
    const delay = window.Shopify && Shopify.designMode ? 1 : parseInt(this.dataset.delay, 10);

    setTimeout(() => {
      this.classList.remove('hidden');
      this.classList.add('is-active');
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      });
    }, delay * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        setTimeout(() => {
          if (miniCart) {
            miniCart.open();
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        setTimeout(() => {
          const summary = headerDrawer?.querySelector('summary');
          if (summary) {
            summary.click();
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'search':
        this.isAction = true;
        
        document.querySelectorAll('search-modal').forEach((searchModal) => {
          const style = window.getComputedStyle(searchModal);
          if (style.display === 'none') {
            return;
          }

          setTimeout(() => {
            const summary = searchModal.querySelector('summary');
            const input = searchModal.querySelector('input:not([type="hidden"])');
            if (!summary || !input) {
              return;
            }

            summary.click();
            
            input.focus();
          }, delay);
        });
        break;
    }
  }

  hideStickyHeader() {
    if (this.header && window.theme?.config?.mqlSmall && this.isAction && this.header.sticky()) {
      setTimeout(() => {
        this.header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  onCartUpdated(event) {
    try {
      const cart = typeof event.detail?.cart === 'string' ? JSON.parse(event.detail.cart) : event.detail?.cart;
      const itemCount = Number(cart?.item_count || 0);
      this.updateCartCount(itemCount);
    } catch (error) {
      return;
    }
  }

  updateCartCount(itemCount) {
    this.querySelectorAll('[data-mobile-dock-cart-count]').forEach((bubble) => {
      bubble.hidden = itemCount === 0;
      bubble.classList.toggle('mobile-dock__cart-count--dot', itemCount >= 100);
      bubble.setAttribute('aria-label', `${itemCount} cart items`);

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) {
        visibleCount.textContent = itemCount < 100 ? itemCount : '';
      }
    });
  }

  waitStickyHeader() {
    if (this.header && !this.header.sticky() && !this.isElementVisible(this.header)) {
      this.header.hide();
      setTimeout(() => this.header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
if (!customElements.get('mobile-dock')) {
  customElements.define('mobile-dock', MobileDock);
}
